export default [
    {
        path: '/mall/goodlist', // 购物车商品列表
        component: resolve => require(['@/pages/ticketmall/goodlist'], resolve),
        meta: { title: "长龙航空", keepAlive: true }
    },
    {
        path: '/mall/addrList', // 商品收货地址
        component: resolve => require(['@/pages/address/addrList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/mall/addAddress', // 商品修改收货地址
        component: resolve => require(['@/pages/address/addAddress'], resolve),
        meta: { title: "长龙航空" }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/mall.js